import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import i18next from "i18next";
import { meAAAGQL, Query } from "@onmo/graphql/graphql";
import { selectIsAuthenticated } from "@onmo/auth";

import { useAppSelector } from "../components/hooks";
import { getAppLanguage, setStoredLanguage } from "../models/language";
import { useCurrentProfile } from "./useProfileSession";

export const useAppLanguage = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const { data } = useQuery<{ me: Query["me"] }>(meAAAGQL, {
    skip: !isAuthenticated,
  });
  const { currentProfile, isLoading: isProfileLoading } = useCurrentProfile();

  const saved = currentProfile?.language ?? data?.me?.language;
  const isPending = isAuthenticated && (!data || isProfileLoading);

  useEffect(() => {
    if (isPending) return;
    const language = getAppLanguage(saved);
    if (saved) setStoredLanguage(language);
    if (i18next.language !== language) i18next.changeLanguage(language);
  }, [saved, isPending]);
};
